import call from "./call";
import {
  CronableTask,
  ScheduledTask,
  ScheduledTaskPayload,
} from "../Models/scheduledTask";

export const getAvailableCronableTasks = async (): Promise<CronableTask[]> => {
  const response = await call.get<{ tasks: CronableTask[] }>(
    "/v1/scheduled_task/available/",
    { snack: { error: "scheduledTask.fetchError" } },
  );
  return response.data.tasks;
};

export const getAllScheduledTasks = async (): Promise<ScheduledTask[]> => {
  const response = await call.get<{ scheduled_tasks: ScheduledTask[] }>(
    "/v1/scheduled_task/",
    { snack: { error: "scheduledTask.fetchError" } },
  );
  return response.data.scheduled_tasks;
};

export const getSingleScheduledTask = async (
  id: number,
): Promise<ScheduledTask> => {
  const response = await call.get<ScheduledTask>(`/v1/scheduled_task/${id}/`);
  return response.data;
};

export const createScheduledTask = async (
  data: ScheduledTaskPayload,
): Promise<ScheduledTask> => {
  const response = await call.post<ScheduledTask>(
    "/v1/scheduled_task/",
    data,
    {
      snack: {
        success: "scheduledTask.createSuccess",
        error: "scheduledTask.createError",
      },
    },
  );
  return response.data;
};

export const updateScheduledTask = async (
  id: number,
  data: ScheduledTaskPayload,
): Promise<ScheduledTask> => {
  const response = await call.put<ScheduledTask>(
    `/v1/scheduled_task/${id}/`,
    data,
    {
      snack: {
        success: "scheduledTask.updateSuccess",
        error: "scheduledTask.updateError",
      },
    },
  );
  return response.data;
};

export const deleteScheduledTask = async (id: number): Promise<void> => {
  await call.delete(`/v1/scheduled_task/${id}/`, {
    snack: {
      success: "scheduledTask.deleteSuccess",
      error: "scheduledTask.deleteError",
    },
  });
};

export const toggleScheduledTask = async (
  id: number,
  enabled: boolean,
): Promise<ScheduledTask> => {
  const response = await call.post<ScheduledTask>(
    `/v1/scheduled_task/${id}/toggle/`,
    { enabled },
    { snack: { error: "scheduledTask.updateError" } },
  );
  return response.data;
};

export const runScheduledTaskNow = async (
  id: number,
): Promise<ScheduledTask> => {
  const response = await call.post<ScheduledTask>(
    `/v1/scheduled_task/${id}/run/`,
    {},
    {
      snack: {
        success: "scheduledTask.runSuccess",
        error: "scheduledTask.runError",
      },
    },
  );
  return response.data;
};

export const getMyScheduledTasks = async (): Promise<ScheduledTask[]> => {
  const response = await call.get<{ scheduled_tasks: ScheduledTask[] }>(
    "/v1/scheduled_task/my/",
    { snack: { error: "scheduledTask.fetchError" } },
  );
  return response.data.scheduled_tasks;
};

export const toggleMyScheduledTask = async (
  id: number,
  enabled: boolean,
): Promise<ScheduledTask> => {
  const response = await call.post<ScheduledTask>(
    `/v1/scheduled_task/my/${id}/toggle/`,
    { enabled },
    { snack: { error: "scheduledTask.updateError" } },
  );
  return response.data;
};

export const deleteMyScheduledTask = async (id: number): Promise<void> => {
  await call.delete(`/v1/scheduled_task/my/${id}/`, {
    snack: {
      success: "scheduledTask.deleteSuccess",
      error: "scheduledTask.deleteError",
    },
  });
};
